<template>
  <div class="media-image">
    <div class="media-image-img">
      <div v-if="imageSrc">
        <img :src="imageSrc" alt="Media image" v-if="contentType === 'image'" />
        <video :src="imageSrc" controls v-if="contentType === 'video'"></video>
      </div>
    </div>

    <div class="media-image-buttons">
      <div class="field has-addons">
        <p class="control">
          <button type="button" class="button is-small is-primary" @click="pick">
            <b-icon icon="upload"></b-icon>
            <span>Upload</span>
          </button>
        </p>

        <p class="control" v-if="image">
          <b-dropdown position="is-bottom-left" hoverable>
            <button type="button" class="button is-small is-warning" slot="trigger">
              <b-icon icon="download"></b-icon>
              <span>Download</span>
            </button>

            <b-dropdown-item has-link>
              <a
                class="has-text-centered"
                v-for="(link, size) in image"
                :key="size"
                :download="size + '.jpg'"
                :href="link"
                target="_blank"
              >{{ size }}</a>
            </b-dropdown-item>
          </b-dropdown>
        </p>
      </div>
    </div>

    <input class="is-hidden" type="file" :accept="accept" ref="fileInput" @change="onPick" />
  </div>
</template>

<script>
import UploadImage from "./UpdateCoverModal";

export default {
  props: {
    modelType: {
      type: String,
      required: true
    },

    modelId: {
      type: String,
      required: true
    },

    collection: {
      type: String,
      required: true
    },

    defaultImageSrc: {
      default: null
    },

    image: {
      type: Object
    },

    withResponsiveImages: {
      type: Boolean,
      default: false
    },

    shouldRemoveOlder: {
      type: Boolean,
      default: false
    },

    contentType: {
      type: String,
      default: "image"
    }
  },

  data() {
    return {
      file: null,

      imageSrc: this.defaultImageSrc
    };
  },

  computed: {
    accept() {
      if (this.contentType === "image") {
        return "image/gif, image/jpeg, image/png";
      }

      if (this.contentType === "video") {
        return ".mp4";
      }

      return "";
    }
  },

  watch: {
    image(value) {
      this.imageSrc = value ? value.md : null;
    }
  },

  methods: {
    pick() {
      this.$refs.fileInput.click();
    },

    onPick() {
      this.confirm();
    },

    confirm() {
      this.$buefy.modal.open({
        component: UploadImage,

        props: {
          file: this.pickedFile(),
          endpoint: "/admin/api/old/media",
          fileFieldName: "file",

          with: {
            model_type: this.modelType,
            model_id: this.modelId,
            collection: this.collection,
            "with-responsive-images": this.withResponsiveImages,
            "should-remove-older": this.shouldRemoveOlder
          },

          updated: image => {
            this.imageSrc = image.url;

            this.$emit("updated", image);
          },

          contentType: this.contentType
        }
      });
    },

    pickedFile() {
      if (this.$refs.fileInput.files.length > 0) {
        return this.$refs.fileInput.files[0];
      }
    }
  }
};
</script>
